
































































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import wxvoidEdit from "../tenantsView/wx-message_voidEdit.vue"; //语音回复表单
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { format } from "path";
//import App from "@/components/Global/GetAppData"; //缓存接口
import { log } from "util";
import { WxVoid } from "@/Entity"; //全局常量
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import Bus from "@/JS/Bus";
@Component({
  components: { wxvoidEdit }
})
export default class extends Vue {
  $message: any;
  //注入数据 @Provide()
  @Provide()
  private pagesize = 10; //每页的数据条数
  private pageIndex = 1; // 默认第一页
  private totalItem = 0; //数据总长度
  private Data = {}; //把行信息传到子组件
  private voidEdit = true;
  private voidTabData = [];
  private VoiceType: string = "0"; //类型
  private VoiceTypeLabel = "试听";
  private audios = document.getElementsByTagName("audio");
  private viewVideo = false;
  private VoiceLink = ""; //查看视频地址
  private VoiceTitle = ""; //查看视频标题
  private loading = false; //加载数据
  private inboxTabData: any = [];
  private Keyword: string = "";
  private Nature: string = "";
  private loadingText = "数据正在同步中，请稍后.....";
  private State: string = ""; //状态
  private scrollHeight = 500; //当前高度
  private GetAppData: any = []; //取应用号信息
  //方法
  private handleClick() {}
  private handleSizeChange(val: any) {
    this.pagesize = val;
    this.getVoidList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = val;
    this.getVoidList();
  }
  //格式化状态
  formatState(row: any, column: any) {
    switch (row.State) {
      case 1:
        return "启用";
      case 0:
        return "禁用";
      case -1:
        return "删除";
    }
  }
  //审核状态
  formatReview(row: any, column: any) {
    switch (row.Review) {
      case 1:
        return "通过";
      case 0:
        return "审核中";
    }
  }
  //新增文本回复
  AddImgTextEdit() {
    this.voidEdit = false;
    this.Data = new WxVoid();
  }
  handleEdit(index: any, row: any) {
    this.Data = row; //把行信息传给data
    this.voidEdit = false;
  }
  //切换媒体类型
  toggleTab() {
    switch (this.VoiceType) {
      case "2":
        this.VoiceTypeLabel = "试看";
        break;
      default:
        this.VoiceTypeLabel = "试听";
        break;
    }
    this.handleCurrentChange(1);
    this.getVoidList();
  }
  //格式化时间
  formatDate(row: any, column: any) {
    if (row.UpdaterDate != null && row.UpdaterDate != "") {
      // var date = new Date(row.UpdaterDate);
      // return FomatDataStr.formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      var date = row.UpdaterDate;
      date = date.replace("T", " ");
      date = date.substring(0, 16);
      return date;
    } else {
      return "";
    }
  }
  //媒体类型
  formatType(row: any, column: any) {
    switch (row.Type) {
      case 1:
        return '回复语音';
        break;
      case 2:
        return '回复视频';
        break;
      case 3:
        return '回复音乐';
        break;
    }
  }
  //素材类型
  formatNature(row: any, column: any) {
    if (row.Nature == `1`) {
      return `永久素材`;
    } else {
      return `临时素材`;
    }
  }
  //格式化匹配度类型
  formatStatus(row: any, column: any) {
    switch (row.Type) {
      case 0:
        return "包含匹配";
      case 1:
        return "完全匹配";
      default:
        return "";
    }
  }

  //表单过来的刷新方法
  refresh() {
    this.getVoidList();
    this.voidEdit = true;
  }
  //初始化
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
     var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj:any) => {
      that.GetAppData.Aid=obj.Aid;   
      that.getVoidList();   
    });
    this.getVoidList();
    this.scrollHeight = document.body.scrollHeight - 440;
  }
  //查看视频
  onViewVideo(param: any) {
    if (param) {
      var data = param.VoiceLink.split(".");
      if (data[data.length - 1] != "mp4") {
        window.open(
          param.VoiceLink,
          "newwin"
        );
      } else {
        this.viewVideo = true;
        this.VoiceLink = param.VoiceLink;
        this.VoiceTitle = param.VoiceTitle;
      }
    } else {
      this.$message.error("视频地址失效");
    }
  }
  //加载表格数据
  //拉取微信素材库
  async GetDownload() {
    this.$confirm(
      "拉取素材前会删除本地的永久素材确定要操作，建议先推送再拉取",
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }
    ).then(async () => {
      this.loadWxData();
    });
  }
  //拉取视频
  async loadWxData() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      this.loading = true;
      this.loadingText = "数据正在拉取中，请稍后.....";
      let params: any = {
        Input: [
          {
            Name: "dto",
            value: { TenantID: AppAccount.TenantID, Aid: AppAccount.Aid }
          },
          { Name: "type", value: this.VoiceType }
        ]
      };
      var res: any = await httpApi.UpdateDbOthersMediaListAsync(params);
      this.loading = false;
      if (res.ErrorCode == 0) {
        this.$message.success("拉取成功！"); 
        this.getVoidList();
      } else {
        this.$message.error(res.ErrorMessage);
      }
    }
  }
  //推送数据
  async GetUpload() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      this.loading = true;
      this.loadingText = "数据正在推送中，请稍后.....";
      let params: any = {
        Input: [
          {
            Name: "dto",
            value: { TenantID: AppAccount.TenantID, Aid: AppAccount.Aid }
          },
          { Name: "type", value: this.VoiceType }
        ]
      };
      var res: any = await httpApi.UploadWxOthersMediaListAsync(params);
      this.loading = false;
      if (res.ErrorCode == 0) {
        this.$message.success(
          "推送成功，注意：视频需要官方审核通过后才可播放！"
        );
        this.loadWxData();
        //this.getImgList();
      } else {
        this.$message.error(res.ErrorMessage);
      }
    }
  }
  //加载数据
  async getVoidList() {
    var _this = this;
    //console.log(this.GetAppData);
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      this.loading = true;
      //搜索的数据 传参
      let params: any = {
        Input: [
          { Name: "Aid", value: AppAccount.Aid },
          { Name: "type", value: this.VoiceType },
          { Name: "keyword", value: this.Keyword },
          { Name: "Nature", value: this.Nature },
          //分页参数
          { Name: "page", value: this.pageIndex },
          { Name: "rows", value: this.pagesize }
        ]
      };
      if (this.State) {
        params.Input.push({ Name: "State", value: this.State });
      }
      //console.log(params);
      var res: any = await httpApi.Getvoid(params);
      this.loading = false;
      if (res.ErrorCode == 0) {
        _this.voidTabData = res.output[0].value;
        //console.log("语音数据", _this.voidTabData);
        _this.totalItem = res.output[1].value; // _this.voidTabData.length;
      } else {
        this.$message.error(res.ErrorMessage);
      }
    }
  }
  //单行删除
  async handleDel(index: any, row: any, act: string) {
    let confirmStr = "确定要删除当前数据吗?";
    if (act == "wxdel")
      confirmStr = "确定要删除当前数据，微信也同步删除确定要操作吗?";
    this.$confirm(confirmStr, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      let model = row as WxVoid; //把行内信息转换成wxText
      var _this = this;
      let AppAccount = this.GetAppData;

      if (AppAccount) {
        model = row;
        model.ActionName = "DELETE";
        let params: any = {
          Input: [
            {
              Name: "AppReplyVoiceDTO",
              value: model
            },
            {
              Name: "act",
              value: act
            }
          ]
        };
        var res: any = await httpApi.Savevoid(params);
        if (res.ErrorCode == 0) {
          this.$message.success("删除成功!");
          this.getVoidList();
        } else {
          this.$message.error("删除失败：" + res.ErrorMessage);
        }
      }

      return new WxVoid();
    });
  }
}
